import { Component, DestroyRef } from '@angular/core';
import { API, AssetFileDTO } from '../../../../services/api/api';
import { ModalService } from '../../../../services/gui/modal/modal.service';
import { UtilService } from '../../../../services/util.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AssetService } from '../../../../services/assets/asset.service';
import { UploadService } from '../../../../services/upload/upload.service';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-asset-edit',
  templateUrl: './asset-edit.component.html',
  styleUrls: ['./asset-edit.component.scss'],
  standalone: false,
})
export class AssetEditComponent {
  urlReg: string;
  form: FormGroup;
  showPreview: boolean;
  private _$destroyUpload: Subject<boolean>;

  constructor(
    public api: API,
    public modalService: ModalService,
    public util: UtilService,
    public assetService: AssetService,
    public uploadService: UploadService,
    private destroyRef: DestroyRef
  ) {
    this._$destroyUpload = new Subject<boolean>();
    this.showPreview = true;
    this.urlReg = '(http|https):\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,4}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)';
    this.form = new FormGroup({
      Link: new FormControl('', [Validators.required, Validators.pattern(this.urlReg)]),
      Thumbnail: new FormControl('', [Validators.pattern(this.urlReg)]),
    });
  }

  get Link() {
    return this.form.get('Link');
  }

  get Thumbnail() {
    return this.form.get('Thumbnail');
  }

  togglePreview() {
    if (!this.showPreview) {
      this.showPreview = true;
      this.uploadService.$allUploadFinished.next(false);
      this._$destroyUpload.next(true);
      this._$destroyUpload.complete();
    } else {
      this.showPreview = false;
      this.uploadService.$allUploadFinished.pipe(takeUntil(this._$destroyUpload)).subscribe((result: boolean) => {
        if (result) {
          this.assetService.refreshSelectedAsset();
        }
      });
    }
  }

  pasteDataFromClipboard(field: string): void {
    navigator.clipboard
      .readText()
      .then((input: string) => {
        if (field === 'link') {
          this.Link.setValue(input);
          this.Link.markAsTouched();
        }
        if (field === 'thumbnail') {
          this.Thumbnail.setValue(input);
          this.Thumbnail.markAsTouched();
        }
      })
      .catch(() => {});
  }

  addLink() {
    if (this.Link?.value && this.Link?.value?.trim().length > 0) {
      const assetFile: AssetFileDTO = new AssetFileDTO();
      assetFile.link = this.Link?.value?.trim();
      if (this.Thumbnail?.value && this.Thumbnail?.valid && this.Thumbnail?.value.trim().length > 0) {
        assetFile.thumbnailLink = this.Thumbnail?.value?.trim();
      }
      this.api
        .dm_assets_Asset_uploadAssetFileLink(this.assetService.selectedAsset.id, assetFile)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe(() => {
          this.Link.setValue('');
          this.Link.markAsUntouched();
          this.assetService.refreshSelectedAsset();
        });
    }
  }

  download(assetFile: AssetFileDTO) {
    window.open(assetFile.link, 'blank');
  }
}
